import { useMemo } from "react";
import { useRecoilValue } from "recoil";
import { deepmerge } from "@mui/utils";
import { issueFilterAtom, FilterBuilderVariables } from "./recoil";

const useFilterBuilder = () => {
  const filterValues = useRecoilValue(issueFilterAtom);
  const filterValuesForCustomizedFilters = useMemo(
    () =>
      Object.entries(filterValues).reduce<FilterBuilderVariables>(
        (filters, [key, filterValue]) => {
          if (!filterValue) return filters;
          if (filterValue.length > 0 && key === "errorReportStatus") {
            const statusFilter = {
              issueStatus: {
                issueStatusName: {
                  in: filterValue,
                },
              },
            };
            const nextFilter = deepmerge(filters, { filters: statusFilter });
            return nextFilter;
          }
          return filters;
        },
        { filters: {} }
      ),
    [filterValues]
  );
  return filterValuesForCustomizedFilters;
};

export default useFilterBuilder;
